module.exports = require("core-js-pure/features/object/set-prototype-of");